export class MachineException {
    id: number;
    machineSerialNumber: string;
    machineInstallationName: string;
    dateTime: Date;
    code: number;
    area: number;
    unitId: number;
    hwId: number;
    hwType: number;
    category: number;
    resolved: Date;
    restoreAttemps: number;
    processType: number;

    constructor() {
        this.id = null;
        this.machineSerialNumber = null;
        this.machineInstallationName = null;
        this.dateTime = null;
        this.area = null;
        this.code = null;
        this.unitId = null;
        this.hwId = null;
        this.hwType = null;
        this.category = null;
        this.resolved = null;
        this.restoreAttemps = null;
        this.processType = null;
    }

    public parse(obj: any) {
        if (obj.Id) this.id = obj.Id;
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.MachineInstallationName) this.machineInstallationName = obj.MachineInstallationName;
        if (obj.DateTime) this.dateTime = new Date(obj.DateTime);
        if (obj.Code != null && obj.Code != undefined) this.code = obj.Code;
        if (obj.Area != null && obj.Area != undefined) this.area = obj.Area;
        if (obj.UnitId != null && obj.UnitId != undefined) this.unitId = obj.UnitId;
        if (obj.HwId != null && obj.HwId != undefined) this.hwId = obj.HwId;
        if (obj.HwType != null && obj.HwType != undefined) this.hwType = obj.HwType;
        if (obj.Category != null && obj.Category != undefined) this.category = obj.Category;
        if (obj.Resolved) this.resolved = obj.Resolved;
        if (obj.RestoreAttemps != null && obj.RestoreAttemps != undefined) this.restoreAttemps = obj.RestoreAttemps;
        if (obj.ProcessType && obj.ProcessType >= 0 && obj.ProcessType < 20) this.processType = obj.ProcessType;
    }

    public getHexCode() {
        return this.code.toString(16).toUpperCase().padStart(3, "0");
    }
}
